import { ErrorMessageConstants } from "../constants/error-message-constants";


export class ResetPasswordInputModel {
  password?: string;
  confirmPassword?: string;
  oldPassword?: string;
  token?: string;

  passwordError?: string = ErrorMessageConstants.FORM_REQUIRE_FIELD;
  confirmPasswordError?: string = ErrorMessageConstants.FORM_REQUIRE_FIELD;
  oldPasswordError?: string = ErrorMessageConstants.FORM_REQUIRE_FIELD;
  slug:string = '';
}
